<div class="long-card" tabindex="0" (keypress)="enterItemByKeyboard($event)"
         [ngClass]="{'pinned':item.pinnedTime}"
         (click)="showDetails()">

    <div class="long-image">
        <!--<img [src]="imageService.safeImage(imageService.imageSourceUrl(item.cover?.source))" class="image"-->
             <!--[class.promotion]="item.isPromotionImage" />-->
        <ig-image [imageUrl]="item.cover?.source" [placeCategoryList]="item.categoryList" [class.promotion]="item.isPromotionImage" [alt]="item.title||item.name"></ig-image>
        <div *ngIf="!item.isPromotionImage" class="ig-title">
            <p>{{item.title||item.name}}</p>
        </div>
        <div class="choice" *ngIf="item.isChoice">
            <mat-icon>favorite</mat-icon>
            <span>{{editorChoiceText}}</span>
        </div>
    </div>

    <div class="align-center" *ngIf="!item.isPromotionImage">
        <div class="long-time flex">
            <div *ngIf="item.startTime" class="time">
                <mat-icon>date_range</mat-icon>
                <span *ngIf="item.eventTimes&&item.eventTimes.length>1">Multiple Dates Event - See Details</span>
                <span *ngIf="item.eventTimes&&item.eventTimes.length<=1" [class.small-time-text]="eventTimeText.length>41">{{eventTimeText}}</span>
            </div>

            <div *ngIf="!item.startTime" category class="time" [matTooltip]="item.category">
                <mat-icon>list</mat-icon>
                <span>{{placeCategory}}</span>
            </div>

            <div class="detail-btn-wrap" role="button">
                details
            </div>
        </div>

    </div>

</div>



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/calendar/long.card/visitor.long.card.component.html